





















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CustomerBank } from '../../entity/CustomerBank';
import { CustomerBankDto } from '../../dto/CustomerBankDto';
import CustomerBankForm from './CustomerBankForm.vue';
import { Pagination } from 'pansx-utils';
import { Page } from 'pansx-utils';
import { QTableRequestOption } from 'pansx-utils';

@Component({
    components: { CustomerBankForm },
})
export default class CustomerBankTable extends Vue {
    public data: CustomerBank[] = [];
    @Prop({ default: () => new Pagination() })
    public readonly pagination!: Pagination;
    public customerBankFormDialog = false;
    public CustomerBankForm = new CustomerBank();
    @Prop({ default: () => new CustomerBank() })
    public readonly filter!: CustomerBank;
    public loading = false;

    public get columns() {
        const columns = CustomerBank.getColumns();
        columns.push({
            label: '编辑',
            name: 'edit',
            field: '',
        });
        return columns;
    }

    public async getAll(q?: QTableRequestOption) {
        this.loading = true;

        try {
            if (typeof q !== 'undefined') {
                this.applyPagination(q.pagination);
            }
            const page = await CustomerBankDto.allPage(
                this.filter,
                this.pagination
            );
            const pg: Pagination = Page.of(page).getPagination();
            if (typeof q !== 'undefined') {
                pg.sortBy = q.pagination.sortBy;
                pg.descending = q.pagination.descending;
            }
            this.applyPagination(pg);
            this.data = page.content;
        } catch (e) {
            this.$q.notify({ message: '错误:' + e, color: 'red' });
        } finally {
            this.loading = false;
        }
    }

    private applyPagination(q: Pagination | undefined) {
        if (typeof q !== 'undefined') {
            this.pagination.descending = q.descending;
            this.pagination.page = q.page;
            this.pagination.rowsNumber = q.rowsNumber;
            this.pagination.rowsPerPage = q.rowsPerPage;
            this.pagination.sortBy = q.sortBy;
        }
    }

    async save(d: CustomerBank) {
        try {
            await CustomerBankDto.save(d);
            this.$q.notify('保存成功!');
        } catch (e) {
            this.$q.notify({ message: '错误:' + e, color: 'red' });
        }
    }

    public editCustomerBank(customerBank: CustomerBank) {
        this.CustomerBankForm = CustomerBank.of(customerBank);
        this.customerBankFormDialog = true;
    }

    public handleCustomerBankFormSubmit() {
        this.CustomerBankForm = new CustomerBank();
        this.customerBankFormDialog = false;
        this.getAll();
    }

    public async addCustomerBank() {
        this.CustomerBankForm = new CustomerBank();
        this.customerBankFormDialog = true;
    }

    public async deleteCustomerBank(customerBank: CustomerBank) {
        try {
            const id = customerBank.id;
            if (typeof id !== 'undefined') {
                await new Promise((resolve, reject) => {
                    this.$q
                        .dialog({
                            cancel: true,
                            message: '真的要删除吗?',
                            persistent: true,
                        })
                        .onOk(async () => {
                            await CustomerBankDto.delete(id);
                            resolve(true);
                        })
                        .onCancel(reject);
                });
            }
            this.$q.notify({ message: '删除成功', color: 'green' });
            await this.getAll();
        } catch (e) {
            this.$q.notify({ message: '删除失败', color: 'red' });
        }
    }

    public mounted() {
        this.getAll();
    }
}
